import styled from 'styled-components'
import { colors } from '../../../theme/Global/index'

export const StyledLocationOffContainer = styled.div`
  width: 100%;
  text-align: center;
`

export const StyledLocationOffIcon = styled.span`
  color: ${colors.white};
  background-color: ${colors.darkGrey};
  display: inline-block;
  border-radius: 3em;
  padding: 0.5em;
  line-height: 0em;
  font-size: 0.5em;
`
